
import { SiriusBaseComponent } from 'sirius-framework';
import { Component } from '@angular/core';

@Component({
    selector: 'inner-menu-sales',
    templateUrl: './inner-menu-sales.component.html',
    styleUrls: ['./inner-menu-sales.component.css']
})
export class InnerMenuSalesComponent extends SiriusBaseComponent<any> {
    constructor() {
        super();
    }
    OnInit() {

    }
}
